import React, { useEffect, useState } from "react";
import { ButtonBase, TabsBase } from "@reusejs/react";
import { useRouter } from "next/router";
import { getAuctionEvents } from "services";
import EventReportCard from "./EventReportCard";
import { useSelector } from "react-redux";

export default function EventReports() {
  const router = useRouter();
  const [events, setEvents] = useState([]);

  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });

  useEffect(() => {
    init();
  }, [currentBranch]);

  const init = async () => {
    const res: any = await getAuctionEvents();
    const data = res.data;
    const pastEventsData = data.filter((item: any) => item.status === "end");
    setEvents(pastEventsData);
  };

  return (
    <div className="w-full p-6 flex flex-col justify-center">
      <div className="min-w-full flex justify-between">
        <div className="w-1/2 text-4xl text-blue-600 font-extrabold dark:text-red-600">
          Auction Reports
        </div>
      </div>
      <TabsBase
        elements={[
          {
            title: <div className="flex items-center px-2">All Reports</div>,
            content: (
              <div className="flex w-full justify-center border-2 border-t-0 rounded-b-lg bg-gray-50 border-gray-200">
                <div className="w-full p-8 mt-4 space-y-6">
                  {events.length > 0 ? (
                    events.map((item: any, index: number) => {
                      return (
                        <EventReportCard
                          key={index}
                          property={item.property_dump}
                          event={item}
                        />
                      );
                    })
                  ) : (
                    <div className="w-full flex justify-center">No Events</div>
                  )}
                </div>
              </div>
            ),
          },
        ]}
        tabsBaseClasses={{
          wrapperClasses: "pt-16",
          layout: "flex items-center justify-center",
          height: "h-full",
          width: "w-full min-w-fit",
          backgroundColor: "bg-white",
          padding: "px-2",
          cursor: "cursor-pointer",
          borderRadius: "rounded-t-lg",
          border: "border-2 border-gray-200",
          activeTabClasses:
            "sticky left-0 right-0 bg-gray-50 border-b-0 scale-y-125 origin-bottom font-bold",
          inactiveTabClasses: "border-gray-200",
        }}
      />
    </div>
  );
}
